/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Keep --window-height in sync so mobile scroll-snap sections use the actual
 * visible viewport height (accounts for dynamic browser chrome on iOS/Android).
 * theme.liquid sets the initial value; this keeps it current on resize/rotation.
 */
(function () {
  function updateWindowHeight() {
    document.documentElement.style.setProperty(
      '--window-height',
      window.innerHeight + 'px'
    );
  }

  window.addEventListener('resize', updateWindowHeight);

  // Delay slightly after rotation so the browser has settled on its new size
  window.addEventListener('orientationchange', function () {
    setTimeout(updateWindowHeight, 200);
  });
})();

// 1. Fungsi Menggeser Slider
window.slideProductImage = function(event, btn, direction) {
  if (event) {
    event.preventDefault(); 
    event.stopPropagation();
  }

  // Mencegah double trigger atau spam klik terlalu cepat
  var now = Date.now();
  if (btn._lastSlide && (now - btn._lastSlide < 250)) {
    return;
  }
  btn._lastSlide = now;

  var slider = btn.parentElement ? btn.parentElement.querySelector('.ProductItem__Slider') : null;
  if (!slider) return;

  var scrollAmount = slider.offsetWidth || slider.clientWidth;
  if (!scrollAmount) return;

  var maxScroll = slider.scrollWidth - scrollAmount;

  // Navigasi memutar (looping) agar tidak macet di ujung
  if (direction > 0 && slider.scrollLeft >= maxScroll - 10) {
    slider.scrollTo({ left: 0, behavior: 'smooth' });
  } else if (direction < 0 && slider.scrollLeft <= 10) {
    slider.scrollTo({ left: maxScroll, behavior: 'smooth' });
  } else {
    slider.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }
};

// 1b. Update Dot Indikator Slider saat Di-scroll / Di-swipe
document.addEventListener('scroll', function(e) {
  var slider = e.target;
  if (!slider || !slider.classList || !slider.classList.contains('ProductItem__Slider')) return;

  var dotsContainer = slider.parentElement ? slider.parentElement.querySelector('.ProductItem__SliderDots') : null;
  if (!dotsContainer) return;

  var dots = dotsContainer.querySelectorAll('.ProductItem__SliderDot');
  if (dots.length === 0) return;

  var width = slider.offsetWidth || slider.clientWidth;
  if (width <= 0) return;

  var activeIndex = Math.round(slider.scrollLeft / width);
  activeIndex = Math.max(0, Math.min(activeIndex, dots.length - 1));

  for (var i = 0; i < dots.length; i++) {
    dots[i].classList.toggle('is-active', i === activeIndex);
  }
}, { capture: true, passive: true });

// 1c. Cegah Navigasi Link Tidak Sengaja saat Melakukan Swipe / Drag Foto di Mobile
(function() {
  var isSwiping = false;
  var startX = 0;
  var startY = 0;
  var moveThreshold = 10; // px threshold

  document.addEventListener('touchstart', function(e) {
    var slider = e.target.closest ? e.target.closest('.ProductItem__Slider') : null;
    if (!slider) return;
    var t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    isSwiping = false;
  }, { passive: true });

  document.addEventListener('touchmove', function(e) {
    if (isSwiping) return;
    var slider = e.target.closest ? e.target.closest('.ProductItem__Slider') : null;
    if (!slider) return;
    var t = e.touches[0];
    var dx = Math.abs(t.clientX - startX);
    var dy = Math.abs(t.clientY - startY);
    if (dx > moveThreshold && dx > dy) {
      isSwiping = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function() {
    if (isSwiping) {
      setTimeout(function() {
        isSwiping = false;
      }, 120);
    }
  }, { passive: true });

  document.addEventListener('click', function(e) {
    var link = e.target.closest ? e.target.closest('.ProductItem__SlideItem a') : null;
    if (!link) return;
    if (isSwiping) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();

// 2. Fungsi Helper URL Gambar
if (typeof window.getSizedImageUrl !== 'function') {
  window.getSizedImageUrl = function(src, size) {
    if (!src) return src;
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return (prefix[0] + '_' + size + suffix);
    }
    return src;
  };
}

// 3. LOGIKA BUKA POP-UP DENGAN TELEPORTASI (ANTI-NYANGKUT)
if (typeof window.openMobileQuickShop !== 'function') {
  window.openMobileQuickShop = function(event, btn) {
    event.preventDefault();
    event.stopPropagation();
    var item = btn.closest('.ProductItem');
    
    var popup = item.querySelector('.ProductItem__HoverBottom');
    var overlay = item.querySelector('.MobileQuickShopOverlay');
    
    if (popup && overlay) {
      var alreadyOpen = document.querySelector('.ProductItem__HoverBottom.is-open, body > .ProductItem__HoverBottom.is-sidebar');
      if (alreadyOpen && alreadyOpen !== popup) {
        if (alreadyOpen._closeTimer) {
          clearTimeout(alreadyOpen._closeTimer);
          alreadyOpen._closeTimer = null;
        }
        var previousOverlay = document.body.querySelector(':scope > .MobileQuickShopOverlay');
        alreadyOpen.classList.remove('is-open', 'is-sidebar');
        if (previousOverlay) previousOverlay.classList.remove('is-open');
        if (alreadyOpen._opener) alreadyOpen._opener.setAttribute('aria-expanded', 'false');
        if (alreadyOpen.originalItem) {
          var previousSlider = alreadyOpen.querySelector('.MobilePopupSliderContainer');
          var previousSwatches = alreadyOpen.querySelector('.MobilePopupSwatchesContainer');
          if (previousSlider) previousSlider.innerHTML = '';
          if (previousSwatches) previousSwatches.innerHTML = '';
          var previousWrapper = alreadyOpen.originalItem.querySelector('.ProductItem__Wrapper');
          if (previousWrapper) {
            if (previousOverlay) previousWrapper.appendChild(previousOverlay);
            previousWrapper.appendChild(alreadyOpen);
          }
        }
      }

      // Simpan referensi kartu asli agar tidak hilang jejak
      popup.originalItem = item;
      popup._opener = btn;
      btn.setAttribute('aria-expanded', 'true');
      
      // TELEPORTASI: Pindahkan elemen pop-up ke Body utama
      document.body.appendChild(overlay);
      document.body.appendChild(popup);

      var desktopSidebar = window.matchMedia('(min-width: 1008px)').matches;
      popup.classList.toggle('is-sidebar', desktopSidebar);
      
      // Salin Slider ke Pop-up
      var originalSlider = item.querySelector('.ProductItem__Slider');
      var popupSliderContainer = popup.querySelector('.MobilePopupSliderContainer');
      if (originalSlider && popupSliderContainer) {
        popupSliderContainer.innerHTML = '';
        var clonedSlider = originalSlider.cloneNode(true);
        clonedSlider.scrollLeft = 0;
        popupSliderContainer.appendChild(clonedSlider);
      }

      // Salin Harga ke Pop-up
      var originalPrice = item.querySelector('.ProductItem__PriceList');
      var popupPriceContainer = popup.querySelector('.MobilePopupPriceList');
      if (originalPrice && popupPriceContainer) {
        popupPriceContainer.innerHTML = originalPrice.innerHTML;
      }

      // Update link "Lihat Detail Selengkapnya"
      var productLink = item.querySelector('.ProductItem__ImageWrapper--default');
      var detailLink = popup.querySelector('.MobilePopupDetailLinkBtn');
      if (productLink && detailLink) {
        detailLink.href = productLink.href;
      }

      // Bangun ulang Swatch Warna di popup dari data kartu (bukan clone DOM)
      // Kumpulkan SEMUA swatch dari berbagai sumber dan gabungkan (deduplicate)
      var infoArea = item.querySelector('.ProductItem__Info');
      var allSwatchElements = [];
      var seenUrls = {};
      
      if (infoArea) {
        // SUMBER UTAMA: Elemen swatch dari SA Variants (Prioritas)
        var saSwatches = infoArea.querySelectorAll('.swatch-view-item, .product-form__text a, .product-form__text .swatch-element');
        saSwatches.forEach(function(el) {
          if (el.closest('.ProductItem__Title') || el.closest('li.swatch')) return;
          
          var swatchHref = el.href;
          
          // Khusus untuk SA Variants versi baru yang menggunakan attribute swatch-url pada div-nya
          if (!swatchHref && el.classList.contains('swatch-view-item')) {
              var urlEl = el.querySelector('[swatch-url]');
              if (urlEl) swatchHref = urlEl.getAttribute('swatch-url');
          }
          
          if (!swatchHref || swatchHref.indexOf('/products/') === -1) {
              var pLink = item.querySelector('.ProductItem__ImageWrapper--default');
              if (pLink) swatchHref = pLink.href;
          }
          
          if (swatchHref) {
              var cleanUrl = swatchHref.split('#')[0].split('?')[0]; 
              if (!seenUrls[cleanUrl]) {
                seenUrls[cleanUrl] = true;
                el.dataset.simulatedHref = swatchHref;
                allSwatchElements.push(el);
              }
          }
        });

      }

      if (allSwatchElements.length === 0 && infoArea) {
        infoArea.querySelectorAll('.ProductMeta__Swatches li.swatch a').forEach(function (el) {
          if (!el.href) return;
          var cleanUrl = el.href.split('#')[0].split('?')[0];
          if (seenUrls[cleanUrl]) return;
          seenUrls[cleanUrl] = true;
          el.dataset.simulatedHref = el.href;
          allSwatchElements.push(el);
        });
      }
      
      var originalSwatchList = allSwatchElements;
      var popupSwatchesContainer = popup.querySelector('.MobilePopupSwatchesContainer');
      
      if (originalSwatchList.length > 0 && popupSwatchesContainer) {
         popupSwatchesContainer.innerHTML = '';
         
         var swatchUl = document.createElement('ul');
         swatchUl.className = 'MobilePopupSwatchList';
         swatchUl.style.setProperty('display', 'flex', 'important');
         swatchUl.style.setProperty('justify-content', 'flex-start', 'important');
         swatchUl.style.setProperty('text-align', 'left', 'important');
         swatchUl.style.setProperty('margin-left', '0', 'important');
         swatchUl.style.setProperty('margin-right', 'auto', 'important');
         popupSwatchesContainer.style.setProperty('text-align', 'left', 'important');
         
         var currentProductUrl = (productLink ? productLink.href : '').split('?')[0];
         
         originalSwatchList.forEach(function(origEl) {
           var swatchHref = origEl.href || origEl.dataset.simulatedHref;
           if (!swatchHref || swatchHref.indexOf('/products/') === -1) return;
           var isActive = (swatchHref.split('?')[0] === currentProductUrl);
           
           // Bangun li swatch baru
           var newLi = document.createElement('li');
           newLi.className = 'MobilePopupSwatchDot' + (isActive ? ' is-active-swatch' : '');
           
           var newA = document.createElement('a');
           newA.href = swatchHref;
           
           // Kloning struktur asli - Ekstrak Background / Color / Image agar rapi di Popup
           var bgEl = (origEl.style && (origEl.style.backgroundImage || origEl.style.backgroundColor)) ? origEl : origEl.querySelector('.star-set-image, .star-set-color, [style*="background-image"], [style*="background-color"]');
           var imgEl = origEl.querySelector('img');
           
           if (bgEl && (bgEl.style.backgroundImage || bgEl.style.backgroundColor)) {
               var bgStyle = '';
               if (bgEl.style.backgroundImage) bgStyle += 'background-image: ' + bgEl.style.backgroundImage.replace(/"/g, "'") + '; background-size: cover; background-position: center; ';
               if (bgEl.style.backgroundColor) bgStyle += 'background-color: ' + bgEl.style.backgroundColor.replace(/"/g, "'") + '; ';
               newA.innerHTML = '<span class="bgcolor" style="' + bgStyle + 'width: 100%; height: 100%; display: block; border-radius: 50%;"></span>';
           } else if (imgEl) {
               var realSrc = imgEl.getAttribute('data-src') || imgEl.getAttribute('data-original') || imgEl.src;
               newA.innerHTML = '<img src="' + realSrc + '" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%; display: block;" />';
           } else {
               newA.innerHTML = origEl.innerHTML || '';
           }
           // Perbaiki lazy-loaded image di dalam hasil kloning
           var imgs = newA.querySelectorAll('img');
           imgs.forEach(function(img) {
               var realSrc = img.getAttribute('data-src') || img.getAttribute('data-original');
               if (realSrc) {
                   if (realSrc.indexOf('{width}') !== -1) {
                       realSrc = realSrc.replace('_{width}x', '_50x').replace('{width}', '50');
                   }
                   if (realSrc.indexOf('//') === 0) {
                       realSrc = 'https:' + realSrc;
                   }
                   img.src = realSrc;
               }
               // Hapus class lazyload agar tidak bentrok
               img.classList.remove('lazyload', 'lazyloading', 'Image--lazyLoad');
               img.style.opacity = '1';
               img.style.visibility = 'visible';
           });
           
           newLi.appendChild(newA);
           swatchUl.appendChild(newLi);
           
           // Pasang klik handler
           newA.addEventListener('click', function(e) {
             e.preventDefault();
             e.stopPropagation();
             var newProductUrl = newA.href.split('?')[0];
             var fullProductUrl = newA.href; // Retain query parameters (e.g. ?variant=...)
             
             // Update visual swatch aktif
             swatchUl.querySelectorAll('.MobilePopupSwatchDot').forEach(function(s) { 
               s.classList.remove('is-active-swatch'); 
             });
             newLi.classList.add('is-active-swatch');
             
             // Update link "Lihat Detail Selengkapnya"
             var detailLinkEl = popup.querySelector('.MobilePopupDetailLinkBtn');
             if (detailLinkEl) detailLinkEl.href = fullProductUrl;
             
             // Fetch data produk baru dan update popup
             fetch(newProductUrl + '.js')
               .then(function(resp) { return resp.json(); })
               .then(function(product) {
                 // Update gambar slider di popup
                 var popSlider = popup.querySelector('.MobilePopupSliderContainer');
                 if (popSlider && product.images && product.images.length > 0) {
                   var slidesHtml = '';
                   var safeTitle = product.title ? product.title.replace(/"/g, '&quot;') : '';
                   product.images.forEach(function(imgUrl) {
                     var sized = window.getSizedImageUrl(imgUrl, '600x');
                     slidesHtml += '<div class="ProductItem__SlideItem"><a href="' + fullProductUrl + '"><img src="' + sized + '" loading="lazy" alt="' + safeTitle + '"></a></div>';
                   });
                   popSlider.innerHTML = '<div class="ProductItem__Slider">' + slidesHtml + '</div>';
                 }
                 
                 // Update judul
                 var popTitle = popup.querySelector('.MobilePopupTitle');
                 if (popTitle) popTitle.innerText = product.title;
                 
                 // Update brand
                 var popBrand = popup.querySelector('.MobilePopupBrand');
                 if (popBrand) {
                   if (product.title && product.title.indexOf(' - ') > -1) {
                     popBrand.innerText = product.title.split(' - ')[0];
                     popBrand.style.display = 'block';
                   } else {
                     popBrand.style.display = 'none';
                   }
                 }
                 
                 // Update harga
                 var popPrice = popup.querySelector('.MobilePopupPriceList');
                 if (popPrice && product.variants && product.variants.length > 0) {
                   var firstVariant = product.variants[0];
                   var priceFormatted = (firstVariant.price / 100).toLocaleString('id-ID');
                   popPrice.innerHTML = '<span class="ProductItem__Price Price Text--subdued">' + priceFormatted + ' IDR</span>';
                 }
                 
                 // Update ukuran
                 var sizesContainer = popup.querySelector('.ProductItem__HoverSizes');
                 var form = popup.querySelector('.ProductItem__HoverAddForm');
                 if (sizesContainer && product.variants) {
                   var sizeOptionKey = null;
                   if (product.options) {
                     product.options.forEach(function(opt) {
                       var optName = opt.name.toLowerCase();
                       if (optName === 'size' || optName === 'ukuran') sizeOptionKey = 'option' + opt.position;
                     });
                   }
                   if (sizeOptionKey) {
                     sizesContainer.innerHTML = '';
                     var targetVariant = null;
                     product.variants.forEach(function(variant) {
                       var sizeValue = variant[sizeOptionKey];
                       if (!sizeValue) return;
                       var badgeStatus = !variant.available ? 'is-sold-out' : '';
                       var badgeHtml = '<span class="ProductItem__HoverSizeBadge ' + badgeStatus + '" onclick="selectHoverVariant(event, this, \'' + variant.id + '\', ' + variant.available + ')">' + sizeValue + '</span>';
                       sizesContainer.insertAdjacentHTML('beforeend', badgeHtml);
                       if (!targetVariant && variant.available) targetVariant = variant;
                     });
                     if (!targetVariant) targetVariant = product.variants[0];
                     if (targetVariant) {
                       var newBadges = sizesContainer.querySelectorAll('.ProductItem__HoverSizeBadge');
                       newBadges.forEach(function(b) {
                         if (b.innerText.trim().toLowerCase() === targetVariant[sizeOptionKey].toLowerCase()) b.classList.add('is-active');
                       });
                       if (form) {
                         var input = form.querySelector('input[name="id"]');
                         var btn = form.querySelector('.ProductItem__HoverAddBtn');
                         if (input) input.value = targetVariant.id;
                         if (btn) {
                           btn.dataset.storeExclusive = window.isStoreExclusiveProduct(product) ? 'true' : 'false';
                           window.setHoverAddBtnState(btn, targetVariant.available);
                         }
                       }
                     }
                   }
                 }
                 
                 // Sinkronkan kartu asli
                 if (origEl) origEl.click();
               })
               .catch(function(err) { console.error('Popup swatch error:', err); });
           });
         });
         
         popupSwatchesContainer.appendChild(swatchUl);
      }

      // Tampilkan perlahan setelah teleportasi selesai
      setTimeout(function() {
        popup.classList.add('is-open');
        overlay.classList.add('is-open');
      }, 15);
      
      document.body.style.overflow = 'hidden'; 
    }
  };
}

// 4. LOGIKA TUTUP POP-UP & KEMBALIKAN KE ASALNYA
if (typeof window.closeMobileQuickShop !== 'function') {
  window.closeMobileQuickShop = function(event, btn) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    
    var popup = document.querySelector('.ProductItem__HoverBottom.is-open');
    var overlay = document.querySelector('.MobileQuickShopOverlay.is-open');
    
    if (popup) {
      popup.classList.remove('is-open');
      if (popup._opener) popup._opener.setAttribute('aria-expanded', 'false');
      if (popup._closeTimer) clearTimeout(popup._closeTimer);
    }
    if (overlay) overlay.classList.remove('is-open');
    
    document.body.style.overflow = '';
    
    // Tunggu animasi menutup selesai, lalu kembalikan elemen ke kartu produknya
    var closeTimer = setTimeout(function() {
      if (popup && popup.originalItem) {
         popup.classList.remove('is-sidebar');
         var sliderBox = popup.querySelector('.MobilePopupSliderContainer');
         var swatchBox = popup.querySelector('.MobilePopupSwatchesContainer');
         if (sliderBox) sliderBox.innerHTML = '';
         if (swatchBox) swatchBox.innerHTML = '';
         
         var wrapper = popup.originalItem.querySelector('.ProductItem__Wrapper');
         if (wrapper) {
             if (overlay) wrapper.appendChild(overlay);
             wrapper.appendChild(popup);
         }
      }
      if (popup) popup._closeTimer = null;
    }, 480);
    if (popup) popup._closeTimer = closeTimer;
  };
}

if (!window.__quickShopEscapeBound) {
  window.__quickShopEscapeBound = true;
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.ProductItem__HoverBottom.is-open')) {
      window.closeMobileQuickShop(null, null);
    }
  });
}

// 4b. HELPER STATE TOMBOL ADD TO CART (Store Exclusive / Sold Out / Available)
window.isStoreExclusiveProduct = function(product) {
  var tags = (product && product.tags) || [];
  if (typeof tags === 'string') tags = tags.split(',').map(function(t) { return t.trim(); });
  return tags.indexOf('store-exclusive__label:Store Exclusive') > -1;
};
window.setHoverAddBtnState = function(btn, isAvailable) {
  if (btn.dataset.storeExclusive === 'true') {
    btn.disabled = true; btn.innerHTML = 'EXCLUSIVELY AT PLAZA INDONESIA';
  } else if (isAvailable) {
    btn.disabled = false; btn.innerHTML = 'ADD TO CART';
  } else {
    btn.disabled = true; btn.innerHTML = 'SOLD OUT';
  }
};

// 5. FUNGSI PILIH UKURAN
if (typeof window.selectHoverVariant !== 'function') {
  window.selectHoverVariant = function(event, badge, variantId, isAvailable) {
    event.preventDefault();
    event.stopPropagation();

    var container = badge.closest('.ProductItem__HoverSizes');
    var form = badge.closest('.ProductItem__HoverBottomInner').querySelector('.ProductItem__HoverAddForm');
    
    var allBadges = container.querySelectorAll('.ProductItem__HoverSizeBadge');
    allBadges.forEach(function(b) { b.classList.remove('is-active'); });
    badge.classList.add('is-active');

    if (form) {
      var input = form.querySelector('input[name="id"]');
      var btn = form.querySelector('.ProductItem__HoverAddBtn');
      if (input) input.value = variantId;
      if (btn) window.setHoverAddBtnState(btn, isAvailable);
    }
  };
}

// 6. FUNGSI ADD TO CART AJAX + BUKA DRAWER
if (typeof window.addToCartAjax !== 'function') {
  window.addToCartAjax = function(btn) {
    var form = btn.closest('form');
    if (!form) return;

    var item = btn.closest('.ProductItem');
    if (item && item.getAttribute('data-is-runway') === 'true') {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    var variantId = idInput.value;
    
    var originalText = btn.innerHTML;
    btn.innerHTML = 'ADDING...';
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      btn.innerHTML = originalText;
      btn.disabled = false;

      // Tutup Pop-up otomatis setelah masuk keranjang
      closeMobileQuickShop(null, btn);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      setTimeout(function() {
        var cartIcon = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]') || document.querySelector('[data-drawer-id="sidebar-cart"]');
        if (cartIcon) cartIcon.click(); 
      }, 150);
    })
    .catch(function(error) {
      btn.innerHTML = originalText;
      btn.disabled = false;
    });
  };
}

// 6b. CEGAH CHECKOUT JIKA ADA PRODUK RUNWAY LOOK DI KERANJANG
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form) return;
  if (form.querySelector('.Cart__RunwayNotice') || document.querySelector('.Cart__RunwayNotice')) {
    var isCheckout = form.action && (form.action.indexOf('/checkout') > -1 || form.action.indexOf('/cart') > -1);
    var submitBtn = e.submitter;
    if (isCheckout || (submitBtn && submitBtn.name === 'checkout')) {
      e.preventDefault();
      e.stopPropagation();
      alert('Runway Look items are available by inquiry only and cannot be checked out. Please remove them to proceed.');
      return false;
    }
  }
}, true);

// 7. SINKRONISASI UPDATE DATA KETIKA GANTI WARNA DI POP-UP
document.addEventListener('DOMContentLoaded', function() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
        var linkElement = mutation.target;
        
        if (linkElement.dataset.lastHref === linkElement.href) return;
        linkElement.dataset.lastHref = linkElement.href;

        var item = linkElement.closest('.ProductItem');

        if (item && linkElement.href) {
          var productUrl = linkElement.href.split('?')[0]; 
          var fullProductUrl = linkElement.href;
          
          if (item.dataset.lastProductUrl === productUrl) return;
          item.dataset.lastProductUrl = productUrl;

          var sliderOverlay = item.querySelector('.ProductItem__HoverSliderOverlay');
          var sliderContainer = item.querySelector('.ProductItem__Slider');
          
          // Cari Pop-up yang sedang aktif dan terbuka milik produk ini
          var activePopup = document.querySelector('.ProductItem__HoverBottom.is-open');
          var isPopupActive = (activePopup && activePopup.originalItem === item);

          if (sliderOverlay) {
            sliderOverlay.style.opacity = '0';
            sliderOverlay.style.transition = 'opacity 0.15s ease';
          }

          fetch(productUrl + '.js')
            .then(function(response) { return response.json(); })
            .then(function(product) {
              if (sliderContainer && product.images && product.images.length > 0) {
                var newSlidesHtml = '';
                var safeTitle = product.title ? product.title.replace(/"/g, '&quot;') : '';

                product.images.forEach(function(imgUrl) {
                  var sizedImg = window.getSizedImageUrl(imgUrl, '600x');
                  newSlidesHtml += '<div class="ProductItem__SlideItem"><a href="' + fullProductUrl + '"><img src="' + sizedImg + '" loading="lazy" alt="' + safeTitle + '"></a></div>';
                });

                sliderContainer.innerHTML = newSlidesHtml;
                sliderContainer.scrollLeft = 0;

                // Update dots jika varian warna berganti
                var dotsContainer = item.querySelector('.ProductItem__SliderDots');
                if (dotsContainer) {
                  if (product.images && product.images.length > 1) {
                    var dotsHtml = '';
                    for (var d = 0; d < product.images.length; d++) {
                      dotsHtml += '<span class="ProductItem__SliderDot' + (d === 0 ? ' is-active' : '') + '"></span>';
                    }
                    dotsContainer.innerHTML = dotsHtml;
                    dotsContainer.style.display = 'flex';
                  } else {
                    dotsContainer.innerHTML = '';
                    dotsContainer.style.display = 'none';
                  }
                }

                // Update tombol arrow slider jika varian warna berganti
                var sliderBtns = item.querySelectorAll('.ProductItem__SliderBtn');
                if (sliderBtns.length > 0) {
                  var showBtns = product.images && product.images.length > 1;
                  sliderBtns.forEach(function(btn) {
                    btn.style.display = showBtns ? '' : 'none';
                  });
                }
                
                // Jika Pop-up sedang terbuka, update juga foto di dalam Pop-up!
                if (isPopupActive) {
                    var popupSliderContainer = activePopup.querySelector('.MobilePopupSliderContainer');
                    if (popupSliderContainer) {
                        popupSliderContainer.innerHTML = '<div class="ProductItem__Slider">' + newSlidesHtml + '</div>';
                    }
                }

                if (sliderOverlay) setTimeout(function() { sliderOverlay.style.opacity = ''; }, 50);
              }

              // Update Harga & Judul di Pop-up atau Desktop Hover
              var originalPrice = item.querySelector('.ProductItem__PriceList');
              var desktopHoverPrice = item.querySelector('.DesktopHoverPrice');
              if (originalPrice && desktopHoverPrice) {
                  setTimeout(function(){ desktopHoverPrice.innerHTML = originalPrice.innerHTML; }, 150);
              }
              
              if (isPopupActive) {
                  var popupTitle = activePopup.querySelector('.MobilePopupTitle');
                  var popupPriceContainer = activePopup.querySelector('.MobilePopupPriceList');
                  var popupDetailLink = activePopup.querySelector('.MobilePopupDetailLinkBtn');
                  
                  if (popupTitle) popupTitle.innerText = product.title;
                  if (popupDetailLink) popupDetailLink.href = linkElement.href;
                  if (originalPrice && popupPriceContainer) {
                      setTimeout(function(){ popupPriceContainer.innerHTML = originalPrice.innerHTML; }, 150);
                  }
              }

              // Update logika pemilihan ukuran
              var sizesContainer = isPopupActive ? activePopup.querySelector('.ProductItem__HoverSizes') : item.querySelector('.ProductItem__HoverSizes');
              var form = isPopupActive ? activePopup.querySelector('.ProductItem__HoverAddForm') : item.querySelector('.ProductItem__HoverAddForm');
              
              if (sizesContainer && product.variants) {
                var sizeOptionKey = null;
                if (product.options) {
                  product.options.forEach(function(opt) {
                    var optName = opt.name.toLowerCase();
                    if (optName === 'size' || optName === 'ukuran') sizeOptionKey = 'option' + opt.position;
                  });
                }

                if (sizeOptionKey) {
                  var activeBadge = sizesContainer.querySelector('.is-active');
                  var activeSizeText = activeBadge ? activeBadge.innerText.trim() : null;

                  sizesContainer.innerHTML = '';
                  var targetVariant = null;

                  product.variants.forEach(function(variant) {
                    var sizeValue = variant[sizeOptionKey];
                    if (!sizeValue) return;
                    var badgeStatus = !variant.available ? 'is-sold-out' : '';
                    var badgeHtml = '<span class="ProductItem__HoverSizeBadge ' + badgeStatus + '" onclick="selectHoverVariant(event, this, \'' + variant.id + '\', ' + variant.available + ')">' + sizeValue + '</span>';
                    sizesContainer.insertAdjacentHTML('beforeend', badgeHtml);

                    if (activeSizeText && sizeValue.trim().toLowerCase() === activeSizeText.toLowerCase()) targetVariant = variant;
                  });

                  if (!targetVariant) targetVariant = product.variants.find(function(v) { return v.available; }) || product.variants[0];

                  if (targetVariant) {
                    var newBadges = sizesContainer.querySelectorAll('.ProductItem__HoverSizeBadge');
                    newBadges.forEach(function(b) {
                      if (b.innerText.trim().toLowerCase() === targetVariant[sizeOptionKey].toLowerCase()) b.classList.add('is-active');
                    });
                    if (form) {
                      var input = form.querySelector('input[name="id"]');
                      var btn = form.querySelector('.ProductItem__HoverAddBtn');
                      if (input) input.value = targetVariant.id;
                      if (btn) {
                        btn.dataset.storeExclusive = window.isStoreExclusiveProduct(product) ? 'true' : 'false';
                        window.setHoverAddBtnState(btn, targetVariant.available);
                      }
                    }
                  }
                }
              }
            })
            .catch(function(error) { if (sliderOverlay) sliderOverlay.style.opacity = ''; });

          // Pembersih Harga Ganda SA Variants
          setTimeout(function() {
            var priceList = item.querySelector('.ProductItem__PriceList');
            if (priceList) {
              var injectedPrice = priceList.querySelector('.price');
              if (injectedPrice) {
                var regularPrice = injectedPrice.querySelector('.price-item--regular');
                var salePrice = injectedPrice.querySelector('.price-item--sale');
                if (regularPrice && salePrice) {
                  var textReg = regularPrice.innerText.replace(/\s+/g, ' ').trim();
                  var textSale = salePrice.innerText.replace(/\s+/g, ' ').trim();
                  if (textReg === textSale) {
                    regularPrice.style.display = 'none';
                  } else {
                    regularPrice.style.textDecoration = 'line-through';
                    regularPrice.style.opacity = '0.6';
                  }
                }
              }
            }
          }, 150);
        }
      }
    });
  });

  function observeLinks(links) {
    links.forEach(function(link) {
      if (link.dataset.isObserved) return;
      link.dataset.isObserved = 'true';
      var item = link.closest('.ProductItem');
      if (item && link.href) {
        item.dataset.lastProductUrl = link.href.split('?')[0];
      }
      observer.observe(link, { attributes: true, attributeFilter: ['href'] });
    });
  }
  
  observeLinks(document.querySelectorAll('.ProductItem__ImageWrapper--default'));

  // Observe document for dynamically added product cards (like AJAX recommendations)
  var domObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // ELEMENT_NODE
            if (node.classList && node.classList.contains('ProductItem__ImageWrapper--default')) {
              observeLinks([node]);
            } else {
              var newLinks = node.querySelectorAll('.ProductItem__ImageWrapper--default');
              if (newLinks.length > 0) observeLinks(newLinks);
            }
          }
        });
      }
    });
  });
  domObserver.observe(document.body, { childList: true, subtree: true });
});

// =========================================================
// SWATCH DI BAWAH JUDUL
// Pilihan warna tidak disalin ke panel hover di atas gambar.
// Jika SA Variants belum memuat, tampilkan swatch bawaan tema di bawah judul.
// =========================================================
(function () {
  window.syncDesktopSwatches = function (item) {
    if (!item) return;
    var container = item.querySelector('.DesktopHoverSwatches');
    var info = item.querySelector('.ProductItem__Info');
    if (!container || !info) return;

    var mainLink = item.querySelector('.ProductItem__ImageWrapper--default');
    var currentUrl = (mainLink ? mainLink.href : '').split('?')[0];

    var entries = [];
    var seen = {};

    // Sumber utama: SA Variants
    info.querySelectorAll('.swatch-view-item, .product-form__text a, .product-form__text .swatch-element').forEach(function (el) {
      if (el.closest('.ProductItem__Title') || el.closest('li.swatch') || el.closest('.ProductMeta__Swatches')) return;
      var href = el.href;
      if (!href && el.classList.contains('swatch-view-item')) {
        var urlEl = el.querySelector('[swatch-url]');
        if (urlEl) href = urlEl.getAttribute('swatch-url');
      }
      if (!href || href.indexOf('/products/') === -1) {
        href = mainLink ? mainLink.href : '';
      }
      if (!href) return;
      var key = href.split('#')[0].split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      entries.push({ src: el, href: href, sa: true });
    });

    // Fallback: swatch bawaan tema (tersembunyi di bawah judul)
    var usingNative = false;
    if (entries.length === 0) {
      info.querySelectorAll('.ProductMeta__Swatches li.swatch a').forEach(function (a) {
        if (!a.href) return;
        entries.push({ src: a, href: a.href, sa: false });
        // Set active style for native swatch if it matches current URL
        if (a.href.split('?')[0] === currentUrl) {
           var swatchLi = a.closest('li.swatch');
           swatchLi.style.borderColor = '#111';
           swatchLi.style.boxShadow = '0 0 0 1.5px #fff, 0 0 0 2.5px #111';
        }
      });
      usingNative = entries.length > 0;
    }

    // Jika SA Variants tidak aktif (mis. di dev lokal), tampilkan swatch bawaan di bawah judul
    // (hanya setelah SA diberi waktu memuat, agar tidak dobel di live).
    item.classList.toggle('use-native-swatches', usingNative && window.__nativeSwatchFallbackReady === true);

    // Color choice already sits under the title. Do not copy it onto the image hover panel.
    container.innerHTML = '';
  }

  // Bangun saat kursor masuk ke kartu (juga untuk kartu AJAX/rekomendasi)
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest ? e.target.closest('.ProductItem') : null;
    if (item) window.syncDesktopSwatches(item);
  });

  // Bangun di awal & setelah SA Variants selesai menyuntikkan swatch
  function syncAll() {
    document.querySelectorAll('.ProductItem').forEach(window.syncDesktopSwatches);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
  window.addEventListener('load', function () {
    syncAll();
    setTimeout(syncAll, 1500);
    setTimeout(function () { window.__nativeSwatchFallbackReady = true; syncAll(); }, 3500);
  });

  // Fungsi untuk swap produk secara manual saat mengklik swatch bawaan tema
  window.fallbackSwapProduct = function (item, productUrl) {
    if (!item) return;
    var cleanUrl = productUrl.split('?')[0];
    
    // Sinkronkan swatch di bawah judul
    item.querySelectorAll('.ProductMeta__Swatches li.swatch a').forEach(function(a) {
       var aClean = a.href.split('?')[0];
       var swatchLi = a.closest('li.swatch');
       if (aClean === cleanUrl) {
           swatchLi.style.borderColor = '#111';
           swatchLi.style.boxShadow = '0 0 0 1.5px #fff, 0 0 0 2.5px #111';
       } else {
           swatchLi.style.borderColor = 'rgba(0,0,0,0.35)';
           swatchLi.style.boxShadow = 'none';
       }
    });

    fetch(cleanUrl + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
         // Update gambar utama
         var mainLink = item.querySelector('.ProductItem__ImageWrapper--default');
         var mainImg = mainLink ? mainLink.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)') : null;
         if (product.featured_image && mainImg) {
            var newSrc = window.getSizedImageUrl(product.featured_image, '600x');
            mainImg.src = newSrc;
            mainImg.dataset.src = newSrc;
            if (mainImg.srcset) mainImg.srcset = newSrc;
            mainImg.style.opacity = '1';
            mainImg.style.visibility = 'visible';
         }
         // Update link, ini juga akan memicu observer untuk update ukuran & slider
         if (mainLink) {
             mainLink.href = product.url;
             setTimeout(function() { window.syncDesktopSwatches(item); }, 50);
         }
      });
  };

  // Delegasi klik untuk swatch bawaan tema di bawah judul
  document.addEventListener('click', function(e) {
    var nativeSwatch = e.target.closest('.ProductItem.use-native-swatches .ProductMeta__Swatches li.swatch a');
    if (nativeSwatch) {
      e.preventDefault();
      e.stopPropagation();
      fallbackSwapProduct(nativeSwatch.closest('.ProductItem'), nativeSwatch.href);
    }
  });

})();

// Global event delegation for Store Availability Modal checkbox
document.addEventListener('change', function(e) {
  if (e.target && e.target.id === 'ShowOnlyAvailableStores') {
    var modal = e.target.closest('.store-availabilities-modal');
    if (modal) {
      modal.classList.toggle('only-available', e.target.checked);
    }
  }
});